import { ChangeStatusActionContext } from "./ChangeStatusActionContext";
import usePrepareChangeStatus from "./usePrepareChangeStatus";
import useChangeStatus from "./useChangeStatus";
import { createRef, useContext } from "react";
import CrudModuleFactoryModal from "@beeldit/core/components/CrudModuleFactoryModal";
import { t } from "i18next";
import { showSuccessMessage } from "@beeldit/core/helpers/messagesHelper";
import { Order } from "@beeldit/ecommerce/orders/models/Order";
import OrderInTransitForm from "@beeldit/ecommerce/orders/components/OrderInTransitForm";
import JSONSchemaForm from "@rjsf/core";

function useChangeStatusAction(onSuccess: any): any {
  const prepareChangeStatus = usePrepareChangeStatus();
  const prepareChangeStatusFunction = (id: any, status: number) =>
    prepareChangeStatus(id, status);

  const onSuccessChangeStatus = () => {
    setShowModal(false);
    showSuccessMessage("successfull_action");
    onSuccess();
  };

  const changeStatus = useChangeStatus();

  const changeStatusFunction = () => changeStatus(onSuccessChangeStatus);

  const contextInstance = useContext(ChangeStatusActionContext);
  const { setShowModal, element, statusId } = contextInstance;

  const modalConfig = {
    contextInstance: contextInstance,
    title: "change_status_order",
    onSubmit: () => changeStatusFunction(),
  };

  const formRef = createRef<JSONSchemaForm>();

  const formConfig = {
    formRef: formRef, // We pass the ref to the form
    onSubmit: () => {
      changeStatusFunction();
    },
    element: element, // We pass the element to the form in order to render it in the modal form
    context: ChangeStatusActionContext,
  };

  const actionTemplate = (
    <CrudModuleFactoryModal modalConfig={modalConfig}>
      <p className={statusId >= Order.IN_TRANSIT ? "text-danger" : ""}>
        {t("change_status_order_" + statusId)}
      </p>
      {statusId === Order.MANAGING_SHIPMENT && (
        <OrderInTransitForm formConfig={formConfig} />
      )}
    </CrudModuleFactoryModal>
  );

  /** END EDIT TABLE ACTION */

  return {
    prepareChangeStatusFunction,
    actionTemplate,
  };
}

export default useChangeStatusAction;
